export function isProductionEnvironment(env: unknown): boolean {
  const e = String(env || '').trim().toLowerCase();
  return e === 'prod' || e === 'production' || e === 'prd';
}
